// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__1C4QH","title":"accordion_title__3g4p7","content":"accordion_content__d5-Og","closed":"accordion_closed__1lUhb"};